import React, { useEffect, useState } from 'react';

import { ClosableBanner } from '@qality/common-components/src/molecules/ClosableBanner';
import { useBannerCloseCounter } from '@qality/common-components/src/test-execution/TestExecutionCycleNavigationBanner/useBannerCloseCounter';
import { User } from '@qality/common-model';
import { isNumber } from '@qality/common-utils/src/TypeUtils';

import { WhitespaceStyled } from './ClosableBannerWithCounter.styled';

type Props = {
  children: React.ReactNode;
  currentUser: User;
  counterKey: string;
  minManualClosesToDisableBanner?: number;
};

export default function ClosableBannerWithCounter({
  children,
  currentUser,
  counterKey,
  minManualClosesToDisableBanner = 3,
}: Props): JSX.Element {
  const [shouldShowBanner, setShouldShowBanner] = useState(false);

  const { isLoading, bannerCloseCounter, incrementBannerCloseCounter } =
    useBannerCloseCounter(counterKey, currentUser);

  useEffect(() => {
    init();
  }, [isLoading]);

  const init = () => {
    if (!isNumber(bannerCloseCounter)) {
      // This means that there was an unknown error when reading the property.
      // We don't want to show the banner in that case.
      setShouldShowBanner(false);
      return;
    }

    setShouldShowBanner(bannerCloseCounter < minManualClosesToDisableBanner);
  };

  const handleOnBannerCloseButtonClick = () => {
    incrementBannerCloseCounter();
    setShouldShowBanner(false);
  };

  if (!shouldShowBanner) {
    return <WhitespaceStyled data-testid='whitespace' />;
  }

  return (
    <ClosableBanner
      buttonProps={{
        onClick: handleOnBannerCloseButtonClick,
      }}
    >
      {children}
    </ClosableBanner>
  );
}
